import vars from '../helpers';
import Swiper, { Navigation, Pagination, Mousewheel, Scrollbar } from 'swiper';

Swiper.use([Navigation, Pagination, Mousewheel, Scrollbar]);

if (vars.winWidth >= 768) {
	$('.article__related').each((index, item) => {
		const $item = $(item);

		const swiper = new Swiper($item.find('.swiper-container')[0], {
			slidesPerView: 'auto',
			mousewheel: true,
			scrollbar: {
				el: $item.find('.article__related__slider__scrollbar')[0],
				draggable: true,
			},
		});
	});
}
